import { useLoadableRemoteConfig } from "@hackler/react-sdk";

export const useCustomRemoteConfig = (key: string) => {
  const { remoteConfig } = useLoadableRemoteConfig();
  const parameterValue = remoteConfig.get(key, "defaultValue");
  return parameterValue !== "defaultValue" && JSON.parse(parameterValue);
};
